var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default-view"},[_c('NavigationBar',{attrs:{"right-buttons":_vm.rightButtons,"left-buttons":_vm.leftButtons,"title":_vm.title}}),_vm._v(" "),_c('div',{staticClass:"app-view"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }